import { createAction } from 'redux-actions-helpers'
import { LessonType } from '../ModulePage/types'

export const fetchLessonsList = createAction(
  '@@admin-lessons-list/FETCH_LESSONS_LIST',
  (id: string): any => ({ id })
)

export const fetchLessonsListSuccess = createAction(
  '@@admin-lessons-list/FETCH_LESSONS_LIST_SUCCESS',
  (result: LessonType[]): any => ({ result })
)

export const fetchLessonsListFailure = createAction(
  '@@admin-lessons-list/FETCH_LESSONS_LIST_FAILURE',
  (error: string): any => ({ error })
)

export const removeLesson = createAction(
  '@@admin-lessons-list/REMOVE_LESSON',
  (id: string, lessonId: string): any => ({ id, lessonId })
)

export const removeLessonSuccess = createAction(
  '@@admin-lessons-list/REMOVE_LESSON_SUCCESS'
)

export const removeLessonFailure = createAction(
  '@@admin-lessons-list/REMOVE_LESSON_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-lessons-list/DESTROY')
